import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12e58d2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "transparent-mask"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "loading",
  class: "d-flex justify-content-center align-items-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "loading-bg position-absolute"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "wave"
}, [/*#__PURE__*/_createElementVNode("canvas", {
  id: "canvas"
})])])], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.isAnimationStart ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true)]),
    _: 1
  });
}